import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap, concat } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RecSearchService } from '../../rec-search-service';
import { DomSanitizer, SafeValue, SafeUrl } from '@angular/platform-browser';
//import { ImageViewerComponent } from '../../../shared/components/ng2-image-viewer';
//import { ImageViewerComponent} from 'ng2-image-viewer';

@Component({
  selector: 'app-ait-image-viewer',
  providers: [RecSearchService],
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.css']
})
export class RecImageViewer implements OnInit {

  public docId: number;
  public book: string;
  public page: string;
  public docImages: Array<string>;
  public datas: Array<string>;
  public isLoading: boolean = true;
  error: any;
  //private firstimage: SafeUrl;
  constructor(
    private route: ActivatedRoute,
    private service: RecSearchService,
    private sanitizer: DomSanitizer
  ) {
    this.docImages = new Array<string>();
    this.book = this.route.snapshot.paramMap.get('book');
    this.page = this.route.snapshot.paramMap.get('page');
    this.docId = Number(this.route.snapshot.paramMap.get('docId'));

    console.log('docId in ctor: ' + this.docId);
    console.log('book in ctor: ' + this.book);
    console.log('page in ctor: ' + this.page);


  }

  ngOnInit() {

    this.getImageByBookPage();


  }
  ngOnChanges(changes: SimpleChanges) {

  }
  getImageByDocID() {
    console.log('making a getImageByDocId call');
    this.service.getImageByDocId(this.docId).subscribe(
      data => {
        //console.log(data);
        this.docImages.push(data);
        //this.ngOnInit()
      },
      error => { this.error = error }
    );
  }
  getNextImage(event: Event) {
    console.log('getNextImage() clicked event: ' + event);
  }
  getImageByBookPage() {
    console.log('1. calling getImageByBookAndPage');
    this.service.getImageByBookAndPage(this.book, this.page, 1, '').subscribe(
      data => {
        let image = data;

        //console.log('2. getImageByBookAndPage returned');

        //console.log('image length on server: ' + data.length);
        //console.log('image length on client: '  + image.length);
        this.docImages.push(image);
        //this.docImages = this.datas;
        //this.firstimage = 'data:image/png;base64' + this.docImages[0]; //this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64' + this.docImages[0]);
        //this.firstimage = this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.docImages[0]);
        console.log('length of the payload: ' + this.docImages[0].length);
        //this.firstimage = "data:image/png;base64" + this.docImages[0];
        this.isLoading = false;
        console.log('docImages length: ' + this.docImages.length);
        //this.ngOnInit();
      },
      error => { this.error = error }
    );
    console.log('line 3');
  }

}
